import { NgModule } from '@angular/core'
import { IconModule, ICON_TYPE } from '@spartacus/storefront'
import { EB_ICON_TYPE } from './interface/eb-icon-type.enum'

@NgModule({
  imports: [IconModule],
  providers: [
    {
      provide: ICON_TYPE,
      useValue: EB_ICON_TYPE
    }
  ]
})
export class EbIconModule {}
